import React from 'react';
import { withSnackbar } from 'notistack';
// import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import { Portlet, PortletBody, PortletHeader } from "../../partials/content/Portlet";
// import { Button } from "react-bootstrap";
import * as registerCrud from "../../crud/register.crud";
import * as companiesCrud from "../../crud/companies.crud";
// import { adjustContractTemplate } from '../../store/helpers/TemplateAdjust';
import BiDynamicForm from '../../partials/layout/BiDynamicForm';
// import DataGridBase from '../../partials/layout/DataGridBase';
import SimpleBox from '../../partials/content/SimpleBox';
// import PortletSpinner from '../../partials/layout/PortletSpinner';
import { connect } from "react-redux";
import moment from 'moment';
import DataGrid, { Column, ColumnFixing, Scrolling, HeaderFilter, FilterRow, FilterPanel, Summary, TotalItem } from 'devextreme-react/data-grid';
// import Common from '../../shared/common';
import { LinearProgress } from "@mui/material";
import { injectIntl } from "react-intl";
// import { Redirect } from "react-router-dom";
import { recordStatusesOptions, contractUserPartyOptions } from '../../shared/lookup';
import {
    listAccountsAllowedViewReportSystemUser,
    listAccountsAllowedViewReportHubUser,
    listAccountsAllowedViewReportSecurityGroupUser,
    listAccountsAllowedViewReportContractUser
} from '../../router/Protector/AccessExceptions';
import { Editing } from 'devextreme-react/data-grid';
import QueryString from 'query-string';
import SystemHelper from "../../shared/systemHelper";

 
const isDateRestrictionEnabled = process.env.REACT_APP_AGGREGATE_12MONTH_LIMIT === "true";
const isActionsEnabled = process.env.REACT_APP_ACTIONS_ENABLED === 'true';
const isScheduledReportsEnabled = process.env.REACT_APP_SCHEDULED_REPORTS_ENABLED === "true";

class AggregateReports extends React.Component {
    constructor(props) {
        super(props);
        this.gridRef = React.createRef();
        this.scheduleGridRef = React.createRef();
        this.formRef = React.createRef();
        this.isCustomFieldsEnabled = SystemHelper.getSettingValueBoolean(SystemHelper.SETTINGS.CUSTOM_FIELDS_ENABLED);
        this.isAssetsEnabled = SystemHelper.getSettingValueBoolean(SystemHelper.SETTINGS.ASSETS_ENABLED);
        this.reportTypes = [];
        if (this.isAssetsEnabled) {
            this.reportTypes.push(
                { value: 'AssetDetails', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.ASSETDETAILS' }) }
            )
        }
        if (isActionsEnabled) {
            this.reportTypes.push(
                { value: 'Actions_All', display: "Actions - All" },
                { value: 'Actions_Open', display: "Actions - Open" },
                { value: 'Actions_Overdue', display: "Actions - Overdue" }
            )
        }
        this.reportTypes.push(
            { value: 'Certificate_ProjectManager', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PROJECTMANAGERCERTIFICATE' }) },
            { value: 'Certificate_Supplier', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTORCERTIFICATE' }) },
            { value: 'Certificate_Client', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CLIENTCERTIFICATE' }) },
            { value: 'Certificate_Supervisor', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.SUPERVISORCERTIFICATE' }) },
            { value: 'CompensationEvent', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.MASTERCOMPENSATIONEVENT' }) },
            { value: 'CompensationEventAssessment_ProjectManager', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.COMPENSATIONEVENTASSESSMENT' }) }
        );

        this.reportTypes.push(
            { value: 'ContractOtherPrice', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTOTHERPRICE' }) },
            { value: 'ContractOtherPriceChange', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTOTHERPRICECHANGE' }) },
        )

        this.reportTypes.push(
            { value: 'ContractSummary', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTSUMMARY' }) }
        )

        if (listAccountsAllowedViewReportContractUser.includes(props.userProfile.accounttype)) {
            this.reportTypes.push(
                { value: 'ContractUser', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTUSER' }) }
            )
        }

        this.reportTypes.push(
            { value: 'MasterDefect', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.MASTERINSPECTIONDEFECT' }) },
            { value: 'DelegatedAction_ProjectManager', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PROJECTMANAGERDELEGATEDACTION' }) },
            { value: 'DelegatedAction_Supervisor', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.SUPERVISORDELEGATEDACTION' }) },
            { value: 'DelegatedAction_Supplier', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTORDELEGATEDACTION' }) },
            { value: 'Documents', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.DOCUMENTS' }) },
            { value: 'EarlyWarning', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.MASTEREARLYWARNINGS' }) },
            { value: 'Extension_ProjectManager', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PROJECTMANAGEREXTENSIONREQUEST' }) },
            { value: 'Extension_Quote', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTORQUOTEEXTENSION' }) },
            { value: 'Forecast_Carbon', display: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.CARBONFORECAST' }) },
            { value: 'Forecast_Cost', display: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.COSTFORECAST' }) }
        )

        if (listAccountsAllowedViewReportHubUser.includes(props.userProfile.accounttype)) {
            this.reportTypes.push(
                { value: 'HubUser', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.HUBUSER' }) }
            )
        }

        if (listAccountsAllowedViewReportSecurityGroupUser.includes(props.userProfile.accounttype)) {
            this.reportTypes.push(
                { value: 'SecurityGroupUser', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.SECURITYGROUPUSER' }) }
            )
        }

        this.reportTypes.push(
            { value: 'Instruction_Client', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PROJECTMANAGERCLIENT' }) },
            { value: 'Instruction_ProjectManager', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PROJECTMANAGERINSTRUCTION' }) },
            { value: 'Instruction_Supervisor', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.SUPERVISORINSTRUCTION' }) },
            { value: 'Instruction_Search', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTORINSTRUCTION' }) },
            { value: 'Meetings', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.MEETINGS' }) },
            { value: 'NonConformance', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.NONCONFORMANCE' }) },
            { value: 'NonConformity', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.NONCONFORMITY' }) },
            { value: 'NonConformity_Submission_ProjectManager', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.NONCONFORMITYSUBMISSIONPROJECTMANAGER' }) },
            { value: 'Notification_ClientToClient', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CLIENTTOCLIENTNOTIFICATION' }) },
            { value: 'Notification_ClientToProjectManager', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.NOTIFICATIONCLIENTTOPM' }) },
            { value: 'Notification_ProjectManagerToClient', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PROJECTMANAGERTOCLIENTNOTIFICATION' }) },
            { value: 'Notification_ProjectManagerToProjectManager', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PROJECTMANAGERTOPROJECTMANAGERNOTIFICATION' }) },
            { value: 'Notification_ProjectManagerToSupervisor', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PROJECTMANAGERTOSUPERVISORNOTIFICATION' }) },
            { value: 'Notification_ProjectManager', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PROJECTMANAGERNOTIFICATION' }) },
            { value: 'Notification_SupervisorToProjectManager', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.SUPERVISORTOPROJECTMANAGERNOTIFICATION' }) },
            { value: 'Notification_SupervisorToSupervisor', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.SUPERVISORTOSUPERVISORNOTIFICATION' }) },
            { value: 'Notification_Supervisor', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.SUPERVISORNOTIFICATION' }) },
            { value: 'Notification_SupplierToSupplier', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTORTOCONTRACTORNOTIFICATION' }) },
            { value: 'Notification_Supplier', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTORNOTIFICATION' }) },
            { value: 'OtherAssesment_ProjectManager', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.OTHERASSESSMENT' }) },
            { value: 'PaymentSummary', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PAYMENTSUMMARY' }) },
            { value: 'PaymentApplication_Supplier', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTORPAYMENTAPPLICATION' }) },
            { value: 'PaymentCertificate_ProjectManager', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PROJECTMANAGERPAYMENTCERTIFICATE' }) },
            { value: 'Programme_Supplier', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTORPROGRAMMEREGISTER' }) },
            { value: 'ProjectList', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PROJECTLIST' }) },
            { value: 'ProjectOrder', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PROJECTMANAGERPROJECTORDERS' }) },
            { value: 'Proposal_Supplier', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTORPROPOSAL' }) },
            { value: 'PurchaseOrderDetail', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PURCHASEORDERDETAIL' }) },
            { value: 'Quotation', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.MASTERQUOTATION' }) },
            { value: 'RFITQ_Supplier', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTORRFITQ' }) },
            { value: 'RFITQ_PM', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTORRFITQPM' }) },
            { value: 'SiteDiary', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.SITEDIARY' }) },
            { value: 'Notification_SupplierToSupervisor', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.SUPPLIERTOSUPERVISORNOTIFICATION' }) },

        )

        if (listAccountsAllowedViewReportSystemUser.includes(props.userProfile.accounttype)) {
            this.reportTypes.push(
                { value: 'SystemUser', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.SYSTEMUSER' }) }
            )
        }

        this.reportTypes.push(
            { value: 'IssueAcceptance_ProjectManager', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PROJECTMANAGERISSUEFORACCEPTANCE' }) },
            { value: 'IssueAcceptance_Supplier', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTORISSUEFORACCEPTANCE' }) },
            { value: 'TaskOrder', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PROJECTMANAGERTASKORDERS' }) },
            { value: 'TestInspection_ProjectManager', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PROJECTMANAGERTESTINSPECTION' }) },
            { value: 'TestInspection_Supervisor', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.SUPERVISORTESTINSPECTION' }) },
            { value: 'TestInspection_Supplier', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTORTESTINSPECTION' }) },
            { value: 'Weather', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.WEATHER' }) },
            { value: 'InstructionToQuote', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.INSTRUCTION_FOR_QUOTE' }) },
            { value: 'RequestForQuote', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.REQUEST_FOR_QUOTE' }) },

            { value: 'ItqQuotation', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.ITQ_QUOTATION' }) },
            { value: 'RfqQuotation', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.RFQ_QUOTATION' }) },
            { value: 'ContractOtherDate', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTOTHERDATE' }) },
            { value: 'ContractOtherDateChange', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.CONTRACTOTHERDATECHANGE' }) },
            { value: 'PackagedProjectOrders', display: this.props.intl.formatMessage({ id: 'REPORTS.WF.PACKAGED_PROJECT_ORDERS' }) },
        )
        this.reportTypes = this.reportTypes.sort((a, b) => a.display.localeCompare(b.display));

        this.runModes = [
            { value: 'instant', display: 'Run Now' },
            ...(isScheduledReportsEnabled
                ? [{ value: 'scheduled', display: 'Schedule Report' }]
                : [])
        ];

        this.frequencies = [
            { value: 'DAILY', display: 'Daily' },
            { value: 'WEEKLY', display: 'Weekly' },
            { value: 'MONTHLY', display: 'Monthly' }
        ];

        this.weekdays = [
            { value: 'MONDAY', display: 'Monday' },
            { value: 'TUESDAY', display: 'Tuesday' },
            { value: 'WEDNESDAY', display: 'Wednesday' },
            { value: 'THURSDAY', display: 'Thursday' },
            { value: 'FRIDAY', display: 'Friday' },
            { value: 'SATURDAY', display: 'Saturday' },
            { value: 'SUNDAY', display: 'Sunday' }
        ];



        this.monthlyOptions = [
            { value: 'FIRST_DAY', display: 'First Day of Month' },
            { value: 'LAST_DAY', display: 'Last Day of Month' },
            ...Array.from({ length: 28 }, (_, i) => {
                const day = i + 1;
                return {
                    value: day,
                    display: this.getOrdinal(day)
                };
            })
        ];

        this.formConfig = {
            buttonText: this.props.intl.formatMessage({ id: 'REPORTS.BUTTON.STARTPROCESS' }),
            fields: [
                { label: this.props.intl.formatMessage({ id: 'REPORTS.FIELDS.REPORTTYPE' }), dataField: 'registertype', editorType: 'dxSelectBox', editorOptions: { showClearButton: true, dataSource: this.reportTypes, valueExpr: 'value', displayExpr: 'display' } },

                {
                    label: 'Run Mode',
                    dataField: 'runmode',
                    visible: () => isScheduledReportsEnabled,
                    editorType: 'dxSelectBox',
                    editorOptions: {
                        showClearButton: false,
                        dataSource: this.runModes,
                        valueExpr: 'value',
                        displayExpr: 'display',
                        defaultValue: 'instant'
                    }
                },
                
                {
                    label: 'Frequency',
                    dataField: 'frequency',
                    editorType: 'dxSelectBox',
                    visible: (obj) => obj.runmode === 'scheduled',
                    validationRules: [{ type: 'required' }],
                    editorOptions: {
                        dataSource: this.frequencies,
                        valueExpr: 'value',
                        displayExpr: 'display',
                        showClearButton: true
                    }
                },

                {
                    label: 'Day of Week',
                    dataField: 'weekday',
                    visible: (obj) =>
                        obj.runmode === 'scheduled' && obj.frequency === 'WEEKLY',
                    editorType: 'dxSelectBox',
                    editorOptions: {
                        dataSource: this.weekdays,
                        valueExpr: 'value',
                        displayExpr: 'display',
                        showClearButton: true
                    }
                },

                {
                    label: 'Monthly Option',
                    dataField: 'monthlyoption',
                    visible: (obj) =>
                        obj.runmode === 'scheduled' && obj.frequency === 'MONTHLY',
                    editorType: 'dxSelectBox',
                    editorOptions: {
                        dataSource: this.monthlyOptions,
                        valueExpr: 'value',
                        displayExpr: 'display',
                        showClearButton: true
                    }
                },

                { resource: 'REPORTS.FIELDS.COMPANY', dataField: 'companyid', editorType: 'dxSelectBox', required: false, editorOptions: { dataSource: this.getCompaniesListOfUserContractsDataSource(), valueExpr: 'companyid', displayExpr: 'name', showClearButton: true, placeholder: this.props.intl.formatMessage({ id: "REPORTS.MESSAGE.COMPANY_PLACEHOLDER" }) }, visible: (obj) => !['AssetDetails'].includes(obj.registertype) },
                { resource: "GENERAL.FORMS.FIELD.START_DATE", dataField: 'startdate', editorType: 'dxDateBox', editorOptions: { showClearButton: true, calendarOptions: { min: new Date(1900, 0, 1), max: new Date(2079, 5, 6) } }, validation: { type: 'range', min: new Date(1900, 0, 1), max: new Date(2079, 5, 6), warning: this.props.intl.formatMessage({ id: 'REPORTS.FORM.VALIDATION.STARTDATE' }) }, visible: (obj) =>
                obj.runmode === 'instant' &&
                ![
                    'Actions_All',
                    'Actions_Open',
                    'Actions_Overdue',
                    'ProjectList',
                    'AssetDetails',
                    'HubUser',
                    'SecurityGroupUser',
                    'ContractSummary',
                    'ContractOtherDate',
                    'ContractOtherDateChange',
                    'ContractOtherPrice',
                    'ContractOtherPriceChange'
                ].includes(obj.registertype) },
                { resource: "GENERAL.FORMS.FIELD.END_DATE", dataField: 'enddate', editorType: 'dxDateBox', editorOptions: { showClearButton: true, calendarOptions: { min: new Date(1900, 0, 1), max: new Date(2079, 5, 6) } }, validation: { type: 'range', min: new Date(1900, 0, 1), max: new Date(2079, 5, 6), warning: this.props.intl.formatMessage({ id: 'REPORTS.FORM.VALIDATION.ENDDATE' }) }, visible: (obj) =>
                obj.runmode === 'instant' &&
                ![
                    'Actions_All',
                    'Actions_Open',
                    'Actions_Overdue',
                    'ProjectList',
                    'AssetDetails',
                    'HubUser',
                    'SecurityGroupUser',
                    'ContractSummary',
                    'ContractOtherDate',
                    'ContractOtherDateChange',
                    'ContractOtherPrice',
                    'ContractOtherPriceChange'
                ].includes(obj.registertype) },
                { resource: 'ACTIONS.FIELD.OWNER_PARTY', dataField: 'ownerparty', editorType: 'dxSelectBox', required: false, editorOptions: { dataSource: contractUserPartyOptions, valueExpr: 'id', displayExpr: 'display', showClearButton: true, placeholder: this.props.intl.formatMessage({ id: "REPORTS.MESSAGE.OWNER_PARTY_PLACEHOLDER" }) }, visible: (obj) => ['Actions_All', 'Actions_Open', 'Actions_Overdue'].includes(obj.registertype) },
                { resource: "REPORTS.FIELDS.DUE_START_DATE", dataField: 'duestartdate', editorType: 'dxDateBox', required: false, editorOptions: { showClearButton: true, calendarOptions: { min: new Date(1900, 0, 1), max: new Date(2079, 5, 6) } }, validation: { type: 'range', min: new Date(1900, 0, 1), max: new Date(2079, 5, 6), warning: this.props.intl.formatMessage({ id: 'REPORTS.FORM.VALIDATION.STARTDATE' }) }, visible: (obj) => ['Actions_All', 'Actions_Open', 'Actions_Overdue'].includes(obj.registertype) },
                { resource: "REPORTS.FIELDS.DUR_END_DATE", dataField: 'dueenddate', editorType: 'dxDateBox', required: false, editorOptions: { showClearButton: true, calendarOptions: { min: new Date(1900, 0, 1), max: new Date(2079, 5, 6) } }, validation: { type: 'range', min: new Date(1900, 0, 1), max: new Date(2079, 5, 6), warning: this.props.intl.formatMessage({ id: 'REPORTS.FORM.VALIDATION.ENDDATE' }) }, visible: (obj) => ['Actions_All', 'Actions_Open', 'Actions_Overdue'].includes(obj.registertype) },

                {
                    resource: 'REPORTS.FIELDS.INCLUDECUSTOMFIELDS',
                    dataField: 'includecustomfields',
                    editorType: 'dxSwitch',
                    visible: (obj) => !['Actions_All', 'Actions_Open', 'Actions_Overdue', 'ContractOtherDate', 'ContractOtherDateChange', 'ContractOtherPrice', 'ContractOtherPriceChange', 'AssetDetails'].includes(obj.registertype),
                    editorOptions: { switchedOffText: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }), switchedOnText: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }) }
                },
                {
                    label: this.props.intl.formatMessage({ id: 'REPORTS.FIELDS.CONTRACTSTATUS' }),
                    visible: (obj) => !['Actions_All', 'Actions_Open', 'Actions_Overdue', 'ProjectList', 'AssetDetails', 'HubUser', 'SecurityGroupUser', 'ContractUser', 'SystemUser'].includes(obj.registertype),
                    groupHorizontalDisplay: true,
                    fields: [
                        { label: this.props.intl.formatMessage({ id: 'REPORTS.FIELDS.COMPLETE' }), dataField: 'contractcomplete', required: false, editorType: 'dxSelectBox', editorOptions: { dataSource: recordStatusesOptions, valueExpr: 'valueExpr', displayExpr: 'displayExpr', defaultValue: '2' } },
                        { label: this.props.intl.formatMessage({ id: 'REPORTS.FIELDS.ARCHIVED' }), dataField: 'contractarchived', required: false, editorType: 'dxSelectBox', editorOptions: { dataSource: recordStatusesOptions, valueExpr: 'valueExpr', displayExpr: 'displayExpr', defaultValue: '2' } }
                    ]
                },
                {
                    label: this.props.intl.formatMessage({ id: 'REPORTS.FIELDS.PROJECTSTATUS' }),
                    visible: (obj) => !['Actions_All', 'Actions_Open', 'Actions_Overdue', 'ProjectList', 'AssetDetails', 'HubUser', 'SecurityGroupUser', 'ContractUser', 'SystemUser'].includes(obj.registertype),
                    groupHorizontalDisplay: true,
                    fields: [
                        { label: this.props.intl.formatMessage({ id: 'REPORTS.FIELDS.COMPLETE' }), dataField: 'projectcomplete', required: false, editorType: 'dxSelectBox', editorOptions: { dataSource: recordStatusesOptions, valueExpr: 'valueExpr', displayExpr: 'displayExpr', defaultValue: '2' } },
                        { label: this.props.intl.formatMessage({ id: 'REPORTS.FIELDS.ARCHIVED' }), dataField: 'projectarchived', required: false, editorType: 'dxSelectBox', editorOptions: { dataSource: recordStatusesOptions, valueExpr: 'valueExpr', displayExpr: 'displayExpr', defaultValue: '2' } }
                    ]
                },
            ]
        };

        this.state = {
            processing: false,
            reportsList: null,
            scheduledReportsList: [],
            showCompanies: false,
            hideCustomFields: false,
            hideContractProjectFields: false,
            hideDateFields: false,
            formData: {}, 
    }}


    componentDidMount() {
        this.loadReports();

        if (isScheduledReportsEnabled) {
            this.loadScheduledReports();
        }

        this.setRefreshTimer();

        const query = QueryString.parse(window.location.search);

        if (query?.reportToken) {
            this.downloadFromToken(query.reportToken);
        }
    }

    setRefreshTimer = () => {
        this.timer = setTimeout(() => {
            if (!this.state.processing) {
                this.loadReports();
            }
            this.setRefreshTimer();
        }, 20000);
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }

    loadReports = () => {
        registerCrud.getRegisterList()
            .then(resp => {
                this.setState({ reportsList: JSON.parse(resp.data.aggregatelist) });
            })
            .catch(err => {
                console.log(err);
            })
    }

    loadScheduledReports = () => {
        registerCrud.getScheduledRegisters()
            .then(resp => {
                this.setState({ scheduledReportsList: resp.data || [] });
            })
            .catch(err => {
                console.log(err);
            })
    }

    getOrdinal = (n) => {
        const s = ["th", "st", "nd", "rd"];
        const v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };

    getSummary = (obj) => {
        if (!obj?.frequency) return '';

        const formatText = (text) =>
            text ? text.charAt(0) + text.slice(1).toLowerCase() : '';

        switch (obj.frequency) {
            case 'DAILY':
                return 'Daily';
            case 'WEEKLY':
                return obj.weekday
                    ? `Weekly (${formatText(obj.weekday)})`
                    : 'Weekly';
            case 'MONTHLY':
        if (obj.monthlyoption === 'FIRST_DAY') return 'Monthly (1st Day)';
        if (obj.monthlyoption === 'LAST_DAY') return 'Monthly (Last Day)';
        if (typeof obj.monthlyoption === 'number')
            return `Monthly (${this.getOrdinal(obj.monthlyoption)} Day)`;
        return 'Monthly';
            default:
                return '';
        }
    };

    formatText = (text) => {
        if (!text) return '';
        return text.charAt(0) + text.slice(1).toLowerCase();
    };


    downloadFromToken = (reportToken) => {
        this.setState({ processing: true });

        registerCrud.downloadByToken(reportToken)
            .then(resp => {

                const disposition = resp.headers['content-disposition'];
                console.log("HEADERS:", resp.headers);

                let fileName = "download.xlsx";

                if (disposition && disposition.includes("filename")) {
                    const match = disposition.match(/filename="?(.+?)"?$/);
                    if (match?.[1]) {
                        fileName = match[1];
                    }
                }

                saveAs(resp.data, fileName);

                this.setState({ processing: false });
            })
            .catch((err) => {
                this.setState({ processing: false });

                const message =
                    err?.response?.data ||
                    err?.response?.statusText ||
                    "Download failed";

                this.props.enqueueSnackbar(message, { variant: 'error' });
                console.error("Download error:", err);
            });
    };

    getCompaniesListOfUserContractsDataSource = () => {
        const datasource = {
            loadMode: 'raw',
            cacheRawData: true,
            load: () => {
                var promise = new Promise((resolve) => {
                    companiesCrud.getCompaniesListOfUserContracts()
                        .then(resp => {
                            resolve(resp.data);
                        })
                });
                return promise;
            }
        }
        return datasource;
    }

    waitFor = (ms) => new Promise(r => setTimeout(r, ms));

    export = async (registertype, dataArr) => {
        try {
            const reportName = this.reportTypes.find(x => x.value === registertype).display;

            var byteCharacters = atob(dataArr);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);

            await saveAs(new Blob([byteArray], { type: 'application/octet-stream' }), reportName + '.xlsx');

            this.setState({ processing: false });
        } catch (error) {
            this.setState({ processing: false });
            this.props.enqueueSnackbar(error.toString(), { variant: 'error', });
            console.log(error);
        }
    }

    onStartNewReport = async (newReportObj, setSubmitting) => {
        let payload = { ...newReportObj };
        SystemHelper.hubspotUpdateEvent("AGGREGATED_REPORTS_START");

        if (payload.registertype && payload.registertype.startsWith("Actions")) {
            let completedParam = 2;
            let overdueParam = 2;
            let includeArchivedParam = 0;
            let includeDeletedParam = 0;

            if (payload.registertype === "Actions_All") {
                completedParam = 2;
                includeArchivedParam = 1;
                includeDeletedParam = 1;
                overdueParam = 2;
            }
            else if (payload.registertype === "Actions_Open") {
                completedParam = 0;
                includeArchivedParam = 0;
                includeDeletedParam = 0;
                overdueParam = 2;
            }
            else if (payload.registertype === "Actions_Overdue") {
                completedParam = 0;
                includeArchivedParam = 0;
                includeDeletedParam = 0;
                overdueParam = 1;
            }

            payload = {
                ...payload,
                registertype: payload.registertype,
                companyid: payload.companyid,
                startdate: moment().format('YYYY-MM-DD'),
                enddate: moment().format('YYYY-MM-DD'),
                optionalfilter: {
                    "@RecordComplete": completedParam,
                    "@RecordOverdue": overdueParam,
                    "@DueStartDate": payload.duestartdate,
                    "@DueEndDate": payload.dueenddate,
                    "@IncludeDeleted": includeDeletedParam,
                    "@IncludeArchived": includeArchivedParam,
                    "@OwnerParty": payload.ownerparty,
                }
            };
        }
        else {
            const startDate = payload.startdate;
            const endDate = payload.enddate;
            payload.startdate = startDate ? moment(payload.startdate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
            payload.enddate = endDate ? moment(payload.enddate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');

            if (isDateRestrictionEnabled && startDate && endDate) {
                const differenceDate = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24);
                if (differenceDate > 365) {
                    this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'REPORTS.MESSAGE.REPORTPROCESSOUTOFDATE' }), { variant: 'error', });
                    setSubmitting(false);
                    return;
                }
            }

            payload.includecustomfields = this.isCustomFieldsEnabled && payload.includecustomfields === true;

            if (payload.includecustomfields && !payload.companyid) {
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'REPORTS.MESSAGE.COMPANY_REQUIRED_FOR_CF' }), { variant: 'error', });
                setSubmitting(false);
                return;
            }
        }

        try {
        if (newReportObj.runmode === "scheduled") {

            delete payload.runmode;

            const summary = this.getSummary(payload);

            let weekday = payload.weekday;
            let monthlyoption = payload.monthlyoption;

            if (payload.frequency === 'DAILY') {
                weekday = null;
                monthlyoption = null;
            }

            if (payload.frequency === 'WEEKLY') {
                monthlyoption = null;
            }

            if (payload.frequency === 'MONTHLY') {
                weekday = null;
            }

            payload = {
                ...payload,
                frequency: payload.frequency,
                weekday: payload.weekday,
                monthlymode: payload.monthlyoption,
                dayofmonth:
                    typeof payload.monthlyoption === 'number'
                        ? payload.monthlyoption
                        : null,
                schedulesummary: summary,
                accountid: this.props.userProfile.accountid,
            };

            await registerCrud.createScheduledRegister(payload);

            this.props.enqueueSnackbar(
            this.props.intl.formatMessage({ id: "SCHEDULED.REPORTS.CREATED" }),
            { variant: 'success' }
            );

            this.loadScheduledReports();
        }
        else {
            delete payload.runmode;
            delete payload.frequency;
            delete payload.weekday;
            delete payload.monthlyoption;
            delete payload.summary;

            await registerCrud.createRegister(payload);

            this.props.enqueueSnackbar(
                this.props.intl.formatMessage({ id: 'REPORTS.MESSAGE.REPORTPROCESSSTARTED' }),
                { variant: 'success' }
            );

            this.loadReports();
        }

        this.setState({ formData: {} }, () => {
            const form = this.formRef?.current?.instance;
            if (form) {
                form.resetValues();
            }
        });

        setSubmitting(false);

    } catch (error) {
        setSubmitting(false);
        this.props.enqueueSnackbar(error.toString(), { variant: 'error' });
        console.log(error);
    }}

    isDownloadIconVisible = (e) => {
        return e.row.data.status === 'Complete' && !this.state.processing;
    }

    onDownloadClick = (e) => {
        e.event.preventDefault();
        this.setState({ processing: true }, () => {
            registerCrud.getRegister(e.row.data.registerid)
                .then(resp => {
                    this.export(e.row.data.registertype, resp.data);
                })
                .catch(err => {
                    this.setState({ processing: false });
                    this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                    console.log(err);
                });
        });
    }

    render() {
        return (
            <Portlet>
                <PortletHeader
                    title={this.props.intl.formatMessage({ id: 'REPORTS.TITLE.AGGREGATEREPORTS' })} />
                <PortletBody >
                    
                    <SimpleBox title={this.props.intl.formatMessage({ id: 'REPORTS.TITLE.STARTANEWPROCESS' })}>
  
                        <BiDynamicForm
                                    config={this.formConfig}
                                    ref={this.formRef}
                                    formData={this.state.formData}
                                    onSubmitHandler={this.onStartNewReport}
                                    valueChangeHandler={(field, value, formData) => {

                                    const safeFormData = {
                                        ...(formData || {}),
                                        [field]: value
                                    };

                                    if (field === 'runmode') {

                                        if (value === 'scheduled') {
                                            const tomorrow = new Date();
                                            tomorrow.setDate(tomorrow.getDate() + 1);

                                            safeFormData.startdate = new Date(1970, 0, 1);
                                            safeFormData.enddate = tomorrow;
                                        }

                                        if (value === 'instant') {
                                            safeFormData.startdate = null;
                                            safeFormData.enddate = null;
                                            safeFormData.frequency = null;
                                            safeFormData.weekday = null;
                                            safeFormData.monthlyoption = null;
                                            safeFormData.summary = null;
                                        }
                                    }

                                    if (['frequency', 'weekday', 'monthlyoption'].includes(field)) {

                                    if (field === 'frequency') {
                                        if (value !== 'WEEKLY') safeFormData.weekday = null;
                                        if (value !== 'MONTHLY') safeFormData.monthlyoption = null;
                                    }
                                }

                                    this.setState({ formData: safeFormData }, () => {
                                    if (this.formRef?.current?.instance) {
                                        this.formRef.current.instance.option("formData", safeFormData);
                                    }
                                });
                            }}                  
                        />
                    </SimpleBox>

                    <div style={{ height: 20 }} />

                    <SimpleBox title={this.props.intl.formatMessage({ id: 'REPORTS.TITLE.AGGREGATEREPORTSLIST' })}>
                        
                        <div style={{ width: '100%', height: 'auto' }}>
                            {
                                this.state.processing && (
                                    <LinearProgress style={{ margin: 20 }} />
                                )
                            }
                            <DataGrid
                                height={"auto"}
                                dataSource={this.state.reportsList}
                                keyExpr="registerid"
                                showBorders={true}
                                showColumnLines={true}
                                showRowLines={true}
                                remoteOperations={false}
                                allowColumnReordering={true}
                                columnAutoWidth={true}
                                rowAlternationEnabled={true}
                                allowColumnResizing={true}
                                columnResizingMode='widget'
                                wordWrapEnabled={true}
                                noDataText={this.props.intl.formatMessage({ id: 'REPORTS.TITLE.NOREPORTSINPROGRESS' })}
                                style={{ width: '100%', height: '100%', maxHeight: '67vh', ...this.props.style }}
                            >
                                <HeaderFilter visible={true} />
                                <FilterRow applyFilter="auto" visible={true} />
                                <FilterPanel visible={true} />
                                <ColumnFixing enabled={true} />

                                <Column caption={this.props.intl.formatMessage({ id: 'REPORTS.CAPTION.REPORTTYPE' })} dataField="registertype" lookup={{ dataSource: this.reportTypes, valueExpr: 'value', displayExpr: 'display' }} />
                                {isScheduledReportsEnabled && (<Column
                                caption="Source"
                                cellRender={(data) => {
                                    const isScheduled = data.data.parentregisterid != null;

                                    return (
                                        <span style={{
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            backgroundColor: isScheduled ? "#1976d2" : "#4caf50",
                                            color: "white",
                                            fontSize: "12px"
                                        }}>
                                            {isScheduled ? "Scheduled" : "Manual"}
                                        </span>
                                    );
                                }}
                                />)}
                                <Column caption={this.props.intl.formatMessage({ id: 'REPORTS.CAPTION.STATUS' })} dataField="status" />
                                <Column caption={this.props.intl.formatMessage({ id: 'REPORTS.CAPTION.REPORTSTART' })} dataField="startdate" dataType='date' format={(date) => moment(date).format('DD/MM/YYYY')} />
                                <Column caption={this.props.intl.formatMessage({ id: 'REPORTS.CAPTION.REPORTEND' })} dataField="enddate" dataType='date' format={(date) => moment(date).format('DD/MM/YYYY')} />
                                <Column caption={this.props.intl.formatMessage({ id: 'REPORTS.CAPTION.PROCESSSTART' })} dataField="createddate" dataType='date' format={(date) => moment(date).format('DD/MM/YYYY  HH:mm')} />
                                <Column caption={this.props.intl.formatMessage({ id: 'REPORTS.CAPTION.PROCESSEND' })} dataField="completeddate" dataType='date' format={(date) => moment(date).format('DD/MM/YYYY  HH:mm')} />
                                <Column caption={this.props.intl.formatMessage({ id: 'REPORTS.CAPTION.DOWNLOAD' })} type="buttons" buttons={[{ hint: 'Download', icon: 'download', visible: this.isDownloadIconVisible, onClick: this.onDownloadClick }]} />

                                <Scrolling mode="virtual" showScrollbar={true} useNative={true} columnRenderingMode="virtual" rowRenderingMode="virtual" />
                                <Summary>
                                    <TotalItem column={0} summaryType="count" />
                                </Summary>
                            </DataGrid>
                        </div>
                    </SimpleBox>

                    <div style={{ height: 20 }} />

                    {isScheduledReportsEnabled && (
                    <SimpleBox title={this.props.intl.formatMessage({ id: 'SCHEDULED.REPORTS.TITLE' })}>
                        <div style={{ width: '100%', height: 'auto' }}>
                            <DataGrid
                                ref={this.scheduleGridRef}
                                height={"auto"}
                                dataSource={this.state.scheduledReportsList}
                                keyExpr="aggregatereportscheduleid"
                                showBorders={true}
                                showColumnLines={true}
                                showRowLines={true}
                                remoteOperations={false}
                                allowColumnReordering={true}
                                columnAutoWidth={true}
                                rowAlternationEnabled={true}
                                allowColumnResizing={true}
                                columnResizingMode='widget'
                                wordWrapEnabled={true}
                                noDataText={this.props.intl.formatMessage({ id: 'SCHEDULED.REPORTS.NO_DATA' })}
                                style={{ width: '100%', height: '100%', maxHeight: '67vh', ...this.props.style }}
                                onRowRemoving={async (e) => {
                                    try {
                                        await registerCrud.deleteScheduledRegister(
                                            e.data.aggregatereportscheduleid
                                        );

                                        this.props.enqueueSnackbar(
                                            this.props.intl.formatMessage({ id: 'SCHEDULED.REPORTS.DELETED' }),
                                            { variant: 'success' }
                                        );

                                    } catch (err) {
                                        e.cancel = true;

                                        this.props.enqueueSnackbar(err.toString(), {
                                            variant: 'error'
                                        });
                                    }
                                }}
                            >
                                <Editing
                                    mode="row"
                                    allowDeleting={true}
                                    useIcons={true}
                                    confirmDelete={true}
                                    texts={{
                                        confirmDeleteTitle: this.props.intl.formatMessage({
                                            id: 'SCHEDULED.REPORTS.CONFIRM.DELETE.TITLE'
                                        }),
                                        confirmDeleteMessage: this.props.intl.formatMessage({
                                            id: 'SCHEDULED.REPORTS.CONFIRM.DELETE.MESSAGE'
                                        })
                                    }}
                                />

                                <HeaderFilter visible={true} />
                                <FilterRow applyFilter="auto" visible={true} />
                                <FilterPanel visible={true} />
                                <ColumnFixing enabled={true} />

                                <Column
                                    caption={this.props.intl.formatMessage({ id: 'REPORTS.CAPTION.REPORTTYPE' })}
                                    dataField="registertype"
                                    lookup={{ dataSource: this.reportTypes, valueExpr: 'value', displayExpr: 'display' }}
                                />

                                <Column
                                    caption={this.props.intl.formatMessage({ id: 'REPORTS.CAPTION.SCHEDULE_SUMMARY' })}
                                    dataField="scheduleSummary"
                                />

                                <Column
                                    caption={this.props.intl.formatMessage({ id: 'REPORTS.CAPTION.REPORTSTART' })}
                                    dataField="startdate"
                                    dataType='date'
                                    format={(date) => date ? moment(date).format('DD/MM/YYYY') : ''}
                                />

                                <Column
                                    caption={this.props.intl.formatMessage({ id: 'REPORTS.CAPTION.REPORTEND' })}
                                    dataField="enddate"
                                    dataType='date'
                                    format={(date) => date ? moment(date).format('DD/MM/YYYY') : ''}
                                />

                                <Column
                                    caption={this.props.intl.formatMessage({ id: 'REPORTS.CAPTION.PROCESSSTART' })}
                                    dataField="createddate"
                                    dataType='date'
                                    format={(date) => date ? moment(date).format('DD/MM/YYYY  HH:mm') : ''}
                                />

                                <Column
                                    caption={this.props.intl.formatMessage({ id: 'SCHEDULED.REPORTS.COLUMN.LASTRUN' })}
                                    dataField="lastrunat"
                                    dataType='date'
                                    format={(date) => date ? moment(date).format('DD/MM/YYYY') : ''}
                                />

                                <Column
                                    caption={this.props.intl.formatMessage({ id: 'SCHEDULED.REPORTS.COLUMN.NEXTRUN' })}
                                    dataField="nextrunat"
                                    dataType='date'
                                    format={(date) => date ? moment(date).format('DD/MM/YYYY') : ''}
                                />

                                <Column
                                    caption={this.props.intl.formatMessage({ id: 'REPORTS.CAPTION.STATUS' })}
                                    dataField="schedulestatus"
                                />

                                <Scrolling
                                    mode="virtual"
                                    showScrollbar={true}
                                    useNative={true}
                                    columnRenderingMode="virtual"
                                    rowRenderingMode="virtual"
                                />

                                <Summary>
                                    <TotalItem column={0} summaryType="count" />
                                </Summary>
                            </DataGrid>
                        </div>
                    </SimpleBox>)}
                </PortletBody>
            </Portlet>
        )
    }
}

const mapStateToProps = store => ({
    userProfile: store.auth.userProfile
});

export default injectIntl(withSnackbar(connect(mapStateToProps)(AggregateReports)));